import React from 'react'
import './footerLinks.scss'

const FooterLinks = ({ title, items }) => {
	return (
		<dl className="footerLinks">
			<dt className="footerLinks_title">{title}</dt>
			{items.map((item) => (
				<dl className="footerLinks_item" key={item.id}>
					<a className="footerLinks_link" href={item.link}>
						{item.text}
					</a>
				</dl>
			))}
		</dl>
	)
}

export default FooterLinks
